import { render, staticRenderFns } from "./SharedModal.vue?vue&type=template&id=2f230dc1&scoped=true"
import script from "./SharedModal.vue?vue&type=script&lang=ts"
export * from "./SharedModal.vue?vue&type=script&lang=ts"
import style0 from "@/css/shared-modal.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./SharedModal.vue?vue&type=style&index=1&id=2f230dc1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f230dc1",
  null
  
)

export default component.exports